module.exports = __webpack_public_path__ + "img/send-bill-and-receipt-th.ab3fa6f.png";